module.exports = require('./helpers/bundle-url').getBundleURL('eaJHN') + "empty.8a55106f.jpg";